import { render } from "./RatingFaces.vue?vue&type=template&id=61af4342&scoped=true&ts=true"
import script from "./RatingFaces.vue?vue&type=script&lang=ts"
export * from "./RatingFaces.vue?vue&type=script&lang=ts"

import "./RatingFaces.vue?vue&type=style&index=0&id=61af4342&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61af4342"]])

export default __exports__